import { render, staticRenderFns } from "./Medientradas.vue?vue&type=template&id=560464d7"
import script from "./Medientradas.vue?vue&type=script&lang=js"
export * from "./Medientradas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports